export default {
  THUMBNAIL_MODE: "thumbnailMode",
  LINES_FRONT_MODE: "linesFrontMode",
  LINES_SIDE_MODE: "linesSideMode",
};
